export default "__VITE_ASSET__3ba55c31__"